export default __webpack_public_path__ + "static/toolbar-light-76e3950a277ada0e0bd01d96a4e98435c3b8a29b707f16d7d2cd7b8f07350dec.mp4";